import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Formik } from 'formik';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { JobCategoryDirectory } from 'pages/Bridges/ManagerValidation/components/JobCategoryDirectory';
import { theme } from 'components/layouts/theme';
import AlertMonitor from '../1616BridgesEpic/components/AlertMonitor';
import HybridContainer from '../1616BridgesEpic/components/HybridContainer';
import HelpBar, { Main } from '../1616BridgesEpic/components/HelpBar';
import FormSection from '../FormSection';
import JobCategoryTable from '../1616BridgesEpic/components/JobCategoryTable';
import { HP_APP_ID, HP_COMPONENT_ID, HP_FIELD_KEYS, DEFAULT_VALUES, VALIDATION_SCHEMA } from './_const';

const EpicHP = props => {
	const hasSubmissionBeenAttempted = useSelector(
		state => state.apps.submissionAttempted,
	);

	const previousSessionValue = useSelector(state => {
		const formIndex = Object.keys(state.apps.allFormsInitial).find(
			formIndex =>
				state?.apps?.allFormsInitial[formIndex]?.id === props.appId,
		);
		const memberKey = formIndex
			? Object.keys(
					state?.apps?.allFormsInitial[formIndex]?.model?.members,
				).find(
					k =>
						state.apps.allFormsInitial[formIndex].model.members[k]
							.id === HP_COMPONENT_ID,
				)
			: null;
		const previousSessionData = memberKey
			? state.apps.allFormsInitial[formIndex].model.members[memberKey]
					.value
			: null;
		if (previousSessionData && typeof previousSessionData === 'string') {
			try {
				return JSON.parse(previousSessionData);
			} catch {
				return null;
			}
		}
		return null;
	});

	const [sJobCategoryHelpSelection, setJobCategoryHelpSelection] =
		useState(null);
	const [sOpen, setOpen] = useState(false);

	const jobCategoryDirectoryKey = Date.now();

	return (
		<ThemeProvider theme={theme}>
			<Box>
				<CssBaseline />
				<Main open={sOpen}>
					<Formik
						initialValues={{
							[HP_FIELD_KEYS.JOB_CATEGORIES]:
								previousSessionValue?.[
									HP_FIELD_KEYS.JOB_CATEGORIES
								] ?? [
									DEFAULT_VALUES[
										HP_FIELD_KEYS.JOB_CATEGORIES
									],
								],
						}}
						validationSchema={VALIDATION_SCHEMA}
						validateOnMount
					>
						{formik => (
							<HybridContainer
								formik={formik}
								hasSubmissionBeenAttempted={
									hasSubmissionBeenAttempted
								}
								fieldKeys={HP_FIELD_KEYS}
								{...props}
							>
								<Box
									sx={{
										display: 'flex',
										flexWrap: 'wrap',
										flexDirection: 'row',
									}}
								>
									<AlertMonitor formik={formik} />
									<FormSection
										id='primary-section'
										fullWidth
										defaultOpen
									>
										<JobCategoryTable
											name={HP_FIELD_KEYS.JOB_CATEGORIES}
											isRequired
											systemID={HP_APP_ID}
											selection={
												sJobCategoryHelpSelection
											}
											setSelection={
												setJobCategoryHelpSelection
											}
											setOpen={setOpen}
										/>
									</FormSection>
								</Box>
							</HybridContainer>
						)}
					</Formik>
				</Main>
				<HelpBar open={sOpen} setOpen={setOpen}>
					<JobCategoryDirectory
						key={jobCategoryDirectoryKey}
						selection={sJobCategoryHelpSelection}
						systemID={HP_APP_ID}
					/>
				</HelpBar>
			</Box>
		</ThemeProvider>
	);
};

export default EpicHP;
